import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressComponent } from './address/address.component';
import { ProductIconComponent } from './product-icon/component/product-icon.component';
import { ProductIconService } from './product-icon/service/product-icon.service';
import { AccessNumberFormatterComponent } from './formatter/access-number-formatter.component';
import { PriceComponent } from './price/price.component';
import { OrderButtonComponent } from './order-button/order-button.component';
import { ProductSelectorComponent } from './order-button/product-selector/product-selector.component';
import { ModalComponent } from './modal/modal.component';
import { FormatterModule, TranslationModule } from '@proximus/ng-common';
import { PipeModule } from '../pipe/pipe.module';
import {
  ButtonModule,
  CurrencyAmountModule,
  LoadingSpinnerModule,
} from '@proximus/ng-common-components';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderSwitchComponent } from './order-switch/order-switch.component';
import { MessageBoxComponent } from './message-box/components/message-box.component';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { DefaultLoadingPageComponent } from './default-loading-page/default-loading-page.component';
import { JORenewalCardComponent } from './jo-renewal-card/jo-renewal-card.component';
import { PatchComponent } from './patch/patch.component';
import { EbuOrderButtonComponent } from './ebu-order-button/ebu-order-button.component';
import { DateFormatterComponent } from './formatter/date-formatter.component';
import { BackLinkComponent } from './back-button/back-link.component';
import { GenericToasterComponent } from './generic-toaster/generic-toaster.component';
import { LoadingModalComponent } from './loading-modal/loading-modal.component';

@NgModule({
  declarations: [
    AddressComponent,
    ProductIconComponent,
    AccessNumberFormatterComponent,
    DateFormatterComponent,
    PriceComponent,
    OrderButtonComponent,
    ProductSelectorComponent,
    ModalComponent,
    OrderSwitchComponent,
    MessageBoxComponent,
    GenericModalComponent,
    GenericToasterComponent,
    DefaultLoadingPageComponent,
    JORenewalCardComponent,
    PatchComponent,
    EbuOrderButtonComponent,
    BackLinkComponent,
    LoadingModalComponent,
  ],
  imports: [
    CommonModule,
    TranslationModule,
    FormatterModule,
    PipeModule,
    CurrencyAmountModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingSpinnerModule,
    ButtonModule,
  ],
  providers: [ProductIconService],
  exports: [
    PriceComponent,
    AddressComponent,
    AccessNumberFormatterComponent,
    DateFormatterComponent,
    OrderButtonComponent,
    ProductIconComponent,
    OrderSwitchComponent,
    MessageBoxComponent,
    GenericModalComponent,
    GenericToasterComponent,
    JORenewalCardComponent,
    EbuOrderButtonComponent,
    PatchComponent,
    BackLinkComponent,
    LoadingModalComponent,
  ],
})
export class SharedModule {}
